export const CustomerCare = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.2 37.1L24 37.3L23.78 37.1C14.28 28.48 8 22.78 8 17C8 13 11 10 15 10C18.08 10 21.08 12 22.14 14.72H25.86C26.92 12 29.92 10 33 10C37 10 40 13 40 17C40 22.78 33.72 28.48 24.2 37.1ZM33 6C29.52 6 26.18 7.62 24 10.16C21.82 7.62 18.48 6 15 6C8.84 6 4 10.82 4 17C4 24.54 10.8 30.72 21.1 40.06L24 42.7L26.9 40.06C37.2 30.72 44 24.54 44 17C44 10.82 39.16 6 33 6Z"
        fill="#C4B57C"
      />
    </svg>
  );
};
